export const LEGAL_CONDITIONS_URL = 'https://www.nedgia.es/quierogasnatural/nota-legal/'

export const DATA_POLICY_URL = 'https://www.nedgia.es/politica-de-privacidad/'
